<template>
  <el-dialog :visible.sync="standardDayVisible" width="800px" title="工作周列表" custom-class="dialogPaddingTop0">
    <el-main>
      <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo" :gutter="24" >
        <el-col :span="12">工作日历</el-col>
      </el-row>
      <!-- 工作日历列表 -->
      <el-table :data="standardDays.datas"
        ref="multipleTable"
        :row-key="handleReserve"
        @row-click="onRowClick"
        class="Trpointer"
        header-cell-class-name="tableHeaderbg">
        <!-- @selection-change="handleSelectionChange" -->
        <!-- @row-click="onRowClick" -->
        <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
        <el-table-column label="日历名称">
          <template slot-scope="scope">{{scope.row.calendar.name}}</template>
        </el-table-column>
        <el-table-column label="周">
          <template slot-scope="scope">
            <div v-if="scope.row.weekDays === 0">
              星期日
            </div>
            <div v-else-if="scope.row.weekDays === 1">
              星期一
            </div>
            <div v-else-if="scope.row.weekDays === 2">
              星期二
            </div>
            <div v-else-if="scope.row.weekDays === 3">
              星期三
            </div>
            <div v-else-if="scope.row.weekDays === 4">
              星期四
            </div>
            <div v-else-if="scope.row.weekDays === 5">
              星期五
            </div>
            <div v-else-if="scope.row.weekDays === 6">
              星期六
            </div>
          </template>

        </el-table-column>
        <el-table-column prop="remark" label="运行">
          <template slot-scope="scope">{{scope.row.workingDay ? '工作日' : '非工作日' }}</template>

        </el-table-column>
        <el-table-column prop="remark" label="描述"></el-table-column>
      </el-table>
    </el-main>
    <standardDay_detail :visible.sync="standardDayDetailVisible"  v-if="standardDayDetailVisible" @exit="onExit" :content="content"/>
  </el-dialog>
</template>

<script>

import standardDay_detail from "@/components/standardDay_detail.vue";

export default {
  components:{
    standardDay_detail,
  },
  data(){
    return {
      standardDays:[],
      standardDayDetailVisible:false,
      content:{},
    }
  },
  props:["visible","detail"],
  computed:{
    standardDayVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData(){
      this.$api.getStandardDay(
        {domainid:this.$route.query.domainid,id:this.detail.id},
        {
          onSucess: resp => {
            this.standardDays = resp.data.data;
          }
        }
      );
    },
    handleReserve(row){
      return row.id
    },
    onRowClick(row){
      this.content=JSON.parse(JSON.stringify(row));
      this.standardDayDetailVisible=true;
    },
    onExit(){
      this.standardDayDetailVisible=false;
      this.getData();

    },
  },
};
</script>
<style lang="scss" scoped>

</style>